import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const UncheckedCircleIcon = (props: IconProps) => (
  <Icon w="32px" h="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="16" cy="16" r="15.5" fill="white" stroke="#D6D6D6" />
  </Icon>
);

export default memo(UncheckedCircleIcon);
